// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Structure_wrapper__2EAC7","header":"Structure_header__2QUC0","container":"Structure_container__3-eq-","message":"Structure_message__27KHP"};